import React, { PureComponent } from 'react'
import { string, node } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import I18nMessage from '../I18nMessage'

class LayoutContent extends PureComponent {
  static propTypes = {
    message: string,
    children: node,
  }

  static defaultProps = {
    message: null,
    children: null,
  }

  render() {
    const { message, children, ...rest } = this.props
    if (message) {
      return <I18nMessage id={message} {...rest} />
    }
    return children
  }
}

export default withI18n(LayoutContent)
